var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3585 3.00411L12.996 4.6408L11.3585 3.00411ZM12.4115 1.56225L7.98385 5.98989C7.75508 6.21834 7.59905 6.50941 7.53544 6.8264L7.12646 8.87362L9.17368 8.46386C9.49066 8.40047 9.78135 8.24507 10.0102 8.01623L14.4378 3.58859C14.5709 3.45554 14.6764 3.29758 14.7484 3.12374C14.8204 2.9499 14.8575 2.76358 14.8575 2.57542C14.8575 2.38725 14.8204 2.20093 14.7484 2.02709C14.6764 1.85325 14.5709 1.6953 14.4378 1.56225C14.3048 1.4292 14.1468 1.32365 13.973 1.25165C13.7991 1.17964 13.6128 1.14258 13.4247 1.14258C13.2365 1.14258 13.0502 1.17964 12.8763 1.25165C12.7025 1.32365 12.5445 1.4292 12.4115 1.56225V1.56225Z",
    stroke: "url(#paint0_linear_2536_957)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3111 10.4196V12.739C13.3111 13.1491 13.1482 13.5424 12.8582 13.8324C12.5683 14.1223 12.175 14.2852 11.7649 14.2852H3.26059C2.8505 14.2852 2.45721 14.1223 2.16724 13.8324C1.87726 13.5424 1.71436 13.1491 1.71436 12.739V4.23471C1.71436 3.82462 1.87726 3.43133 2.16724 3.14136C2.45721 2.85138 2.8505 2.68848 3.26059 2.68848H5.57994",
    stroke: "url(#paint1_linear_2536_957)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2536_957",
    x1: 7.12646,
    y1: 5.0081,
    x2: 14.8575,
    y2: 5.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2536_957",
    x1: 1.71436,
    y1: 8.48686,
    x2: 13.3111,
    y2: 8.48686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3154C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon16X16);
export default __webpack_public_path__ + "static/media/edit_icon_16x16.4a4b03e487b5d62fcaab7f71dc12316c.svg";
export { ForwardRef as ReactComponent };